import React, { createContext, useContext, useState, useRef } from 'react';

const AdminAuthContext = createContext(null);

export const API = process.env.REACT_APP_API_URL || 'http://localhost:4001';

export function AdminAuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem('nexus_admin_token'));
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem('nexus_admin_user')); } catch { return null; }
  });
  const tokenRef = useRef(token);

  const login = (tok, usr) => {
    localStorage.setItem('nexus_admin_token', tok);
    localStorage.setItem('nexus_admin_user', JSON.stringify(usr));
    tokenRef.current = tok;
    setToken(tok);
    setUser(usr);
  };

  const logout = () => {
    localStorage.removeItem('nexus_admin_token');
    localStorage.removeItem('nexus_admin_user');
    tokenRef.current = null;
    setToken(null);
    setUser(null);
  };

  const authFetch = async (path, options = {}) => {
    const res = await fetch(`${API}${path}`, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${tokenRef.current}`,
        ...(options.headers || {}),
      },
    });
    if (res.status === 401) {
      logout();
    }
    return res;
  };

  return (
    <AdminAuthContext.Provider value={{ token, user, login, logout, authFetch, isAuthenticated: !!token }}>
      {children}
    </AdminAuthContext.Provider>
  );
}

export function useAdminAuth() {
  return useContext(AdminAuthContext);
}
